import { render } from "./PointOfContact.vue?vue&type=template&id=a5fd6c10&scoped=true"
import script from "./PointOfContact.vue?vue&type=script&lang=js"
export * from "./PointOfContact.vue?vue&type=script&lang=js"

import "./PointOfContact.vue?vue&type=style&index=0&id=a5fd6c10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fd6c10"]])

export default __exports__